import { lazy, Suspense, type ReactNode } from 'react'
import { Route, Routes } from 'react-router-dom'

const PublicPresentationPage = lazy(() => import('@/pages/playbook/PublicPresentationPage'))

/** Keep public presentations outside the component that initializes admin auth. */
export function PresentationRouteBoundary({ children }: { children: ReactNode }) {
  return (
    <Routes>
      <Route
        path="/share/:token"
        element={
          <Suspense
            fallback={
              <div className="flex min-h-dvh items-center justify-center bg-black text-white">
                Loading presentation
              </div>
            }
          >
            <PublicPresentationPage />
          </Suspense>
        }
      />
      <Route path="*" element={children} />
    </Routes>
  )
}
